<mat-tab-group animationDuration="2000ms">
  <mat-tab label="Connections">
    <table mat-table matSort #c2cSort="matSort" [dataSource]="dsC2Cs" class="adminTable">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
        <td mat-cell *matCellDef="let c2c"> {{c2c.id}} </td>
      </ng-container>
      <ng-container matColumnDef="c0">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Character 1 </th>
        <td mat-cell *matCellDef="let c2c"> {{getCharName(c2c.c0)}} </td>
      </ng-container>
      <ng-container matColumnDef="c1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Character 2 </th>
        <td mat-cell *matCellDef="let c2c"> {{getCharName(c2c.c1)}} </td>
      </ng-container>
      <ng-container matColumnDef="connection">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>  Connection </th>
        <td mat-cell *matCellDef="let c2c"> {{c2c.connection}} </td>
      </ng-container>
      <ng-container matColumnDef="comment">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>  Comment </th>
        <td mat-cell *matCellDef="let c2c"> {{c2c.comment}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="dcC2Cs"></tr>
      <tr mat-row *matRowDef="let row; columns: dcC2Cs;"
      ></tr>
    </table>
    <mat-paginator #c2cPaginator [pageSizeOptions]="[5, 10, 20]"
      showFirstLastButtons
      aria-label="Select page of periodic elements">
    </mat-paginator>
    <table>
      <tr><th>Character 1</th><td>
      <mat-select [(value)]="c0" >
        @for (c of chars | keyvalue; track c) {
          <mat-option value="{{c.value.id}}" >{{c.value.id}}-{{c.value.name}}</mat-option>
        }
      </mat-select>

    </td></tr>
    <tr><th>Character 2</th><td>
    <mat-select [(value)]="c1">
      @for (c of chars | keyvalue; track c) {
        <mat-option value="{{c.value.id}}" >{{c.value.id}}-{{c.value.name}}</mat-option>
      }
    </mat-select>

  </td></tr>
  <tr><th>Connection</th><td>
  <mat-select [(value)]="connection">
    <mat-option value="Wife" >Wife</mat-option>
    <mat-option value="Follower" >Follower</mat-option>
    <mat-option value="Children" >Children</mat-option>
    <mat-option value="Husband" >Husband</mat-option>
    <mat-option value="Squire" >Squire</mat-option>
    <mat-option value="Relative" >Relative</mat-option>
    <mat-option value="Other" >Other</mat-option>

  </mat-select>

</td></tr>
<tr><th>Comment</th><td>
<input [(ngModel)]="comment" type="text" placeholder="Comment"/>
</td></tr>
<tr><th></th><td>
<button mat-button (click)="addConnection()">Add connection</button>
</td></tr>
</table>
</mat-tab>
<mat-tab label="Player list">
  <table mat-table matSort #playerSort="matSort" [dataSource]="dsPlayers" class="adminTable">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
      <td mat-cell *matCellDef="let plyr"> {{plyr.cid}} </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
      <td mat-cell *matCellDef="let plyr"> {{plyr.name}} </td>
    </ng-container>
    <ng-container matColumnDef="character">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Character </th>
      <td mat-cell *matCellDef="let plyr"> {{getCharName(plyr.character)}} </td>
    </ng-container>
    <ng-container matColumnDef="right">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>  Right </th>
      <td mat-cell *matCellDef="let plyr"> {{plyr.playerrights}} </td>
    </ng-container>
    <ng-container matColumnDef="did">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>  Discord </th>
      <td mat-cell *matCellDef="let plyr"> {{plyr.did}} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
      (click)="clickPlayer(row)"
    ></tr>
  </table>
</mat-tab>
<mat-tab label="Characters">
  <table mat-table matSort #charSort="matSort" [dataSource]="dsChars" class="adminTable">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
      <td mat-cell *matCellDef="let chr"> {{chr.id}} </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
      <td mat-cell *matCellDef="let chr"> {{chr.name}} </td>
    </ng-container>
    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
      <td mat-cell *matCellDef="let chr"> {{chr.role}} </td>
    </ng-container>
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>  Right </th>
      <td mat-cell *matCellDef="let chr"> {{chr.type}} </td>
    </ng-container>
    <ng-container matColumnDef="plyr">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>  Player </th>
      <td mat-cell *matCellDef="let chr"> {{getPlyrName(chr.player)}} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="dcChars"></tr>
    <tr mat-row *matRowDef="let row; columns: dcChars;"
      (click)="clickChar(row)"
    ></tr>
  </table>
  <mat-paginator #charPaginator [pageSizeOptions]="[5, 10, 20]"
    showFirstLastButtons
    aria-label="Select page of periodic elements">
  </mat-paginator>
</mat-tab>
<mat-tab label="Tokens">
  <table mat-table matSort #tokenSort="matSort" [dataSource]="dsTokens" class="adminTable">
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
      <td mat-cell *matCellDef="let chr"> {{chr.id}} </td>
    </ng-container>
    <ng-container matColumnDef="expires">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Expires </th>
      <td mat-cell *matCellDef="let chr"> {{chr.expires}} </td>
    </ng-container>
    <ng-container matColumnDef="cid">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>  Player </th>
      <td mat-cell *matCellDef="let chr"> {{chr.cid}} </td>
    </ng-container>
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>  State </th>
      <td mat-cell *matCellDef="let chr"> {{chr.tokenstate}} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="dcTokens"></tr>
    <tr mat-row *matRowDef="let row; columns: dcTokens;"
      (click)="clickChar(row)"
    ></tr>
  </table>

</mat-tab>
<mat-tab label="Maps">
  <div style="padding:12px">
    <app-maps-admin></app-maps-admin>
  <!--button mat-raised-button color="primary" (click)="openMapsAdmin()">Open Maps Admin</button-->
</div>
</mat-tab>
</mat-tab-group>
